const r = (e = [], t = {}) => {
  const a = e.map((n) => encodeURIComponent(n)).join("/"), o = Object.entries(t).map(
    ([n, c]) => `${encodeURIComponent(n)}=${encodeURIComponent(String(c))}`
  ).join("&");
  return `${a}${o ? "?" + o : ""}`;
}, p = (e = [], t = {}) => `/${r(e, t)}`, l = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  absolute: p,
  relative: r
}, Symbol.toStringTag, { value: "Module" }));
export {
  p as a,
  l as p,
  r
};
